import { generateTypes } from '../utils/HttpReducerHelper';

const lenderProductsStatus = generateTypes('LENDER', 'PRODUCT_STATUS');
const lenderToggleStatusBySection = generateTypes('LENDER', 'TOGGLE_STATUS_SECTION');

const lenderProduct = generateTypes('LENDER', 'PRODUCT');

const updateLenderProduct = generateTypes('LENDER', 'PRODUCT_UPDATE');

const lenderProductOffer = generateTypes('LENDER', 'PRODUCT_OFFER');

export {
  lenderProductsStatus,
  lenderToggleStatusBySection,
  lenderProduct,
  updateLenderProduct,
  lenderProductOffer,
};
